













































import { Component, Prop, Vue } from "vue-property-decorator";
import CONST_DATA from "@/general/mixins/const/constData";
import { WhatsNewDetailsModel } from "@/general/store/models";
import dayjs from "dayjs";

@Component({
  filters: {
    customDateFormat(value: string) {
      return dayjs(value.split("T")[0])
        .locale("ja")
        .format("YYYY-MM-DD");
    }
  }
})
export default class TheL01NewsList extends Vue {
  @Prop({ type: Array, required: true }) newsList!: [];
  @Prop({ type: Object, required: true }) pageNavi!: any;
  @Prop({ type: String, required: true }) searchKeyword!: string;
  @Prop({ type: String, required: true }) slug!: string;

  get showPageNavi() {
    return this.pageNavi.maxPage > 1;
  }
  get currentPage() {
    return this.pageNavi.currentPage;
  }
  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  get whatsNewList(): Array<WhatsNewDetailsModel> {
    return this.newsList.map((w: WhatsNewDetailsModel) => ({
      pk: w.pk,
      title: w.title,
      message: w.message,
      created_at: w.created_at,
      updated_at: w.updated_at,
      author: w.author,
      author_name: w.author_name,
      employeeId: w.employeeId,
      page_details: w.page_details,
      start_showing: w.start_showing
    }));
  }
}
